import * as DocumentStatus from "app/common/constants/document.status";
import * as DocumentType from "app/common/constants/document.type";
import * as IntegrationsType from "app/common/constants/integrations.type";
import PLANS from "app/common/constants/plans.config";
import * as ProviderStatus from "app/common/constants/provider.status";
import * as ProviderEmailStatus from "app/common/constants/provider-email.status";
import * as RequestStatus from "app/common/constants/request.status";

export default {
  DocumentStatus,
  ProviderStatus,
  RequestStatus,
  DocumentType,
  ProviderEmailStatus,
  IntegrationsType,
  FILE_RENAME_OPTIONS: [
    {
      title: "First Name",
      value: "{{firstName}}",
    },
    {
      title: "Last Name",
      value: "{{lastName}}",
    },
    {
      title: "Date & Time",
      value: "{{date}}",
    },
    {
      title: "Month",
      value: "{{mm}}",
    },
    {
      title: "Year",
      value: "{{yyyy}}",
    },
  ],
  FILE_RENAME_LIMIT: 6,
  ATTACHMENTS_LIMIT_MB: 50,
  VIDEO_ELEMENT_STORAGE_LIMIT_MB: 100,
  FILE_UPLOAD_LIMIT: Infinity,
  SURVICATE_SURVEY_ID: import.meta.env.VITE_SURVICATE_SURVEY_ID,
  PLANS,
  UI_SIZE: {
    EMAIL_FIELDS: {
      WIDTH: 592,
    },
  },
};
